import Swiper from 'swiper';

const SeoSlider = {
  init() {
    if ($('.process-card').length > 0) {
      this.initSlider();
    }
  },

  initSlider() {
    const slider = new Swiper('.process-card', {
      loop: true,
      speed: 700,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      slidesPerView: 1,
      spaceBetween: 0,
      breakpoints: {
        768: {
          slidesPerView: 4,
        },
        576: {
          slidesPerView: 2,
        },
        480: {
          slidesPerView: 1,
        },
      },
    });

    // Pause autoplay when the user hovers over the slider
    $('.process-card').on('mouseenter', () => {
      slider.autoplay.stop();
    });

    // Resume autoplay when the user stops hovering over the slider
    $('.process-card').on('mouseleave', () => {
      slider.autoplay.start();
    });
  },
};

export default SeoSlider;



// WEBPACK FOOTER //
// ./scripts/modules/components/_seo-slider.js